import React from "react";

export default function Component(props: {
})
{
  return (
    <>
      <h1>RiNgLy</h1>
      <p>Testing client-app deployment over Azure Front Door CDN.</p>
    </>
  );
}
